export default __webpack_public_path__ + "static/media/wallet--dark.307c5384.svg";